import Vue from "vue";
import Router from "vue-router";
import store from "../store/index";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      component: () => import("@/views/index/index"),
      meta: {
        title: "Swisse斯维诗防伪查询",
        // 缓存首页
        // keepAlive: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  store.dispatch("setCurPage", to.path);
  next();
  // let { title, needLogin } = to.meta;
  // let { isLogin } = store.state;
  // document.title = title;

  // if (needLogin && !isLogin) {
  //   next({
  //     path:"//login",
  //   });
  // } else {
  //   next();
  // }
});

export default router;
